<template>
  <v-container class="container1" v-if="affiliate" :class="getThemeColor">
    <v-row class="d-flex align-center" style="overflow:hidden;">
      <div class="d-flex align-center justify-center">
          <v-img
            :src="ip+affiliate.logo.url"
            data-aos="showupeffect" data-aos-duration="2000"
            contain
            max-height="105"
            max-width="200"
          >
          </v-img>
        <div class="kitchen-name-container" :class="getThemeColor">
          <div style="position:relative;overflow: hidden;">
            <div data-aos-anchor=".title-border" class="d-flex title-border border-white" data-aos="custom-fade" data-aos-duration="2000" style='min-width:100%;padding:1px;'></div>
            <div :class="$i18n.locale=='en'?'georgia font-size-XXL':'NotoSerifTC font-size-XXL-chi'" class="recipestitle2" style="opacity: 0;cursor:default">{{ $t('affiliate_gallery_page.title')}}</div>
            <div :class="$i18n.locale=='en'?'georgia font-size-XXL':'NotoSerifTC font-size-XXL-chi'"  class="recipestitle2" data-aos-easing="ease-out" data-aos="custom-title-fade-in" data-aos-duration="2000" data-aos-delay="1000">{{ $t('affiliate_gallery_page.title')}}</div>
            <div data-aos-anchor=".title-border" class="d-flex title-border border-white" data-aos="custom-fade" data-aos-duration="2000" style='min-width:100%;padding:1px;'></div>
          </div>
        </div>
      </div>
    </v-row>
    <v-row class="d-flex" data-aos="fade-up" data-aos-duration="3000" style="margin-top:20px">
      <v-col :class="$i18n.locale=='en'?'DinCond font-size-s6':'MHeiHK'" class="videoblog" col="6" xs="6" sm="6" xl="3" lg="3" md="3" v-for="(event, i) in affiliate.EventPhotos" :key="event.id">
        <div :class="$i18n.locale=='en'?'DinCond font-size-s6':'MHeiHK'" class="video-card" @click="openDialog(event, i)">
          <v-img
            :src="ip+event.event_photos[0].formats.small.url"
            alt="John"
            height="73.2%"
            width="100%"
            class="video-card-image"
          >
          </v-img>
          <div :class="$i18n.locale=='en'?'DinCond font-size-s6':'MHeiHK'" class="video-card-desc">
            <div class="name">{{event.event_name[$i18n.locale]}}</div>
            <div class="date">{{event.event_date}}</div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row class="d-flex ma-0 pa-1" style="margin-top:20px;position:relative;" :class="getThemeColor">
       <router-link :to="'/affiliate/'+affiliate_id" style="margin-left: auto;">
        <div :class="$i18n.locale=='en'?'DinCond font-size-s5':'MHeiHK'" class="button" style="float:left;margin-left: auto;"><span style="padding-right:10px" v-html="$t('affiliate_gallery_page.about_affiliate', { affiliate_name: affiliate.name[$i18n.locale] })"></span>
        <simple-line-icons
          icon="arrow-right"
          size="small"
          class="siis"
          no-svg
        /></div>
      </router-link>
      <div class="showfromtop" data-aos="showeffect" data-aos-duration="3000"></div>
    </v-row>
    <div class="custom-dialog" :class="dialog?'custom-dialog-show':''">
      <div class="overlay" @click.self.stop="dialog = false;photoIndex=0;" >
        <div class="main-dialog" :class="dialog?'ddd':''">
          <div style="position:absolute;top:0;bottom:0;left:0;right:0;background:white;opacity:0.9;"></div>
            <v-row class="ma-0 pa-3">
              <v-icon @click="dialog = false;photoIndex=0;" style="cursor:pointer;color:black;margin-left: auto;" size=36>mdi-close</v-icon>
            </v-row>
            <v-row class="pa-0 inner-dialog">
              <v-col sm=1 md=1 lg=1 xl=1 class="d-flex justify-center align-center" style="z-index:0;cursor:pointer;" v-on:click="photoIndex==0?photoIndex=currentEvent.event_photos.length-1:photoIndex--;">
                  <simple-line-icons
                    icon="arrow-left"
                    class="align-self-center"
                    color="black"
                    style="font-size:60px;"
                    no-svg
                  />
              </v-col>
              <v-col sm=10 md=10 lg=10 xl=10 style="z-index:0;" class="pa-1">
                <div :class="$i18n.locale=='en'?'DinCond font-size-s6':'MHeiHK'" class="text-left overlay-title">
                  {{currentEvent.event_name[$i18n.locale]}} <span style="color:mediumseagreen;"> {{currentEvent.event_date}}</span>
                </div>
                <v-img
                  :src="ip+currentEvent.event_photos[photoIndex].url"
                  max-height="560px"
                  contain
                />
              </v-col>
              <v-col sm=1 md=1 lg=1 xl=1 class="d-flex justify-center align-center" style="z-index:0;cursor:pointer;" v-on:click="photoIndex==currentEvent.event_photos.length-1?photoIndex=0:photoIndex++;">
                <simple-line-icons
                  icon="arrow-right"
                  color="black"
                  style="font-size:60px;"
                  no-svg
                />
              </v-col>
              <v-col sm=10 md=10 lg=10 xl=10 class="d-flex justify-center align-center" style="margin:auto;margin-top:0;padding-top:0;">
                <v-row class="d-flex" style="margin-top:0;padding-top:0; padding-bottom:60px">
                  <v-col sm=2 md=2 lg=2 xl=2 class="pa-1" style="cursor:pointer;" v-for="(p, i) in currentEvent.event_photos" :key="p.id" >
                    <v-img
                      :src="ip+p.formats.small.url"
                      alt="John"
                      v-on:click="photoIndex=i"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment'
var ip = "https://lorencegroup.com/api";
export default {
  name: 'AffiiateGallery',
  components: {
  },
  data: () => ({
    dialog: false,
    affiliate: null,
    ip: ip,
    affiliate_id: null,
    currentEvent: null,
    photoIndex: 0,
    currentEventIndex: 0,
  }),
  methods: {
    openDialog(event, i){
      this.dialog = true;
      this.currentEvent = event;
      this.currentEventIndex = i;
    },
  }, 
  mounted () {
    this.affiliate_id = this.$router.history.current.params.affiliate_id
    axios.get(ip+"/affiliates/"+this.$router.history.current.params.affiliate_id)
    .then(response => {
      this.affiliate=response.data;
      this.affiliate.name=[]
      this.affiliate.name["en"] = this.affiliate.display_name_english;
      this.affiliate.name["zh_TW"] = this.affiliate.display_name_trad_chinese;
      this.affiliate.EventPhotos.forEach(an => {
        an.event_date = moment(an.event_date, "YYYY-MM-DD").format("DD MMM YYYY");
        an.event_name=[]
        an.event_name["en"] = an.display_event_name_english;
        an.event_name["zh_TW"] = an.display_event_name_trad_chinese;
      });
      this.currentEvent = this.affiliate.EventPhotos[0]
      console.log(this.affiliate)
    })
    .catch(e => {
      console.log(e)
      //this.errors.push(e)
    })
  },
  computed: {
    getThemeColor: function(){
      return {
        'black-theme': this.affiliate.theme=='black',
        'green-theme': this.affiliate.theme=='green'
      }
    },
  }
}
</script>

<style scoped>
.recipestitle2{
  text-transform: uppercase;
  letter-spacing: 5px;
  margin:auto;
  padding: 10px 26px;
  margin-top:7px;
  margin-bottom:7px;
  color: white;
  cursor: default;
}

.overlay-title{
  letter-spacing: 2px; 
  padding-bottom:10px;
}

.container1{
  padding: 3%;
  height: 100%;
}
.custom-dialog{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
}
.custom-dialog-show{
  z-index: 1;
}
.custom-dialog .overlay{
  height: 100%;
  width: 100%;
}
.custom-dialog .main-dialog{
  position: relative;
  width: 70%;
  margin: auto;
}
.custom-dialog .main-dialog span{
  color: #132b1b;
}

.custom-dialog .main-dialog .special-text{
  color: mediumseagreen;
  z-index: 0;
}
@media (min-width: 768px) { 
  .custom-dialog .main-dialog{
    width: 100%;
    top: 50px;
    max-width: 800px;
  }
  .inner-dialog{
    max-width: 800px;
    margin: auto;
  }
}
@media (min-width: 992px) { 
  .custom-dialog .main-dialog{
    width: 80%;
    top: 50px;
    max-width: 900px;
  }
  .inner-dialog{
    max-width: 800px;
    margin: auto;
  }
}
@media (min-width: 1264px) {
  .custom-dialog .main-dialog{
    width: 80%;
    top: 50px;
    max-width: 1100px;
  }
  .inner-dialog{
    max-width: 800px;
    margin: auto;
  }
}
@media (min-width: 1904px) { 
  .custom-dialog .main-dialog{
    width: 70%;
    top: 50px;
    max-width: 1300px;
  }
  .inner-dialog{
    max-width: 800px;
    margin: auto;
  }
}

.page-title{
  font-family: Georgia, 'Times New Roman', Times, serif;
  letter-spacing: 5px;
  color: white;
  padding: 10px;
  border-top: 1px white solid;
  border-bottom: 1px white solid;
  margin-left:50px;
}
.videoblog{
  position: relative;
  margin-top:20px;
  cursor: pointer;
}
.video-card{
  cursor: pointer;
  position: relative;
  padding-top:80.3%;
}
.video-card-image{
  position: absolute;
  top:0;
  left:0;
}
.video-card-desc{
  letter-spacing: 2px;
  position: absolute;
  padding: 1px;
  padding-left: 10px;
  text-align: left;
  top:77.2%;
  left:0;
  height: 22.8%;
  width: 100%;
  color: white;
  border-left: 1px solid green;
  border-bottom: 1px solid green;
}
.video-card-desc .name{
  color: white;
}
.video-card-desc .date{
  color: mediumseagreen;
}


.button{
  margin: auto;
  color: green;
  border: green solid 1px;
  display: flex;
  width: fit-content;
  align-items:center;
  cursor: pointer; 
  transform: scale(1, .8);

}

.button:hover{
  color:white;
  background: mediumseagreen;
  border: mediumseagreen solid 1px;
}

.video-card:hover > .video-card-desc .name{
  color: mediumseagreen;
}
.video-card:hover > .video-card-desc .date{
  color: white;
}
</style>